module.exports = __webpack_public_path__ + "img/icon-sessions.972ebcda.svg";